// @flow
import { connect } from 'react-redux';

import { selectIsAuthenticatedUser } from '@gandi/authentication';
import type { TranslatorProps } from '@gandi/translate';

import { selectWelcomeOfferEnabled } from 'src/modules/app/selectors';

import type { FullState } from '../../../types';
import { selectSearchValue } from '../../modules/selectors/search';

import AlreadyCustomerBox from './AlreadyCustomerBox';
import OfferBox from './OfferBox';

type StateProps = {
  isWelcomeOfferAppliable: boolean,
  hasSearchValue: string | void,
};

type Props = {
  translator: TranslatorProps,
  ...StateProps,
};

function WelcomeOffer({
  isWelcomeOfferAppliable,
  hasSearchValue,
  translator,
}: Props) {
  if (!isWelcomeOfferAppliable || !!hasSearchValue) {
    return null;
  }
  return (
    <>
      <OfferBox translator={translator} />
      <AlreadyCustomerBox translator={translator} />
    </>
  );
}

const selectIsWelcomeOfferAppliable = (state: FullState) =>
  selectWelcomeOfferEnabled(state) && !selectIsAuthenticatedUser(state);

const mapStateToProps = (state: FullState): StateProps => ({
  // $FlowFixMe[incompatible-return]
  isWelcomeOfferAppliable: selectIsWelcomeOfferAppliable(state),
  hasSearchValue: selectSearchValue(state),
});

// $FlowFixMe[signature-verification-failure]
// $FlowFixMe[underconstrained-implicit-instantiation]
export default connect(mapStateToProps)(WelcomeOffer);
